<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import ListAuthors from '@app-components/ListAuthors.svelte';

  import { getProfileStore } from '@stores/profile';

  import 'tippy.js/themes/light.css';

  import PinnedListActionsBar from './PinnedListActionsBar.svelte';
  import PinnedListCarousel from './PinnedListCarousel.svelte';
  import Track from '@utils/track';
  import { getCurrentUserStore } from '@stores/current_user';
  let currentUser = getCurrentUserStore('default');

  const dispatch = createEventDispatcher();

  export let id;
  export let mobile = false;
  export let user;

  let groupsStore = getProfileStore('groupsStore');
  let groupCollectionStore = getProfileStore('groupCollectionStore');
  let group = groupsStore.find(id);
  export let groupCollections;

  export let bookmarkId = null;

  $: authors = group && group.users.filter((u) => u.role != 'viewer');

  let tileClicked = function (e) {
    Track.spotlightListClicked({
      currentUser: currentUser,
      user: user,
      groupBase: group,
      path: location.pathname,
    });
    dispatch('tile-clicked', { event: e });
  };

  let extractText = function (html) {
    // Remove all HTML tags using a regular expression
    return html.replace(/<\/?[^>]+(>|$)/g, '').replace(/&nbsp;/g, ' ');
  };

  onMount(() => {
    let sub = group.subscribe((x) => (group = x));
    let subGC = groupCollectionStore.subscribe((x) => (groupCollections = x));

    return () => {
      sub();
      subGC();
    };
  });
</script>

<style style="text/scss" lang="scss">
  .tile-container {
    height: inherit;
  }

  .main-content {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .group-name-container {
      color: #1a1a1a;
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;
      margin-top: 8px;
      cursor: pointer;

      &:hover {
        color: #717171;
      }
    }

    .group-metadata-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
    }

    .tile-group-description {
      font-size: 14px;
      line-height: 20px;
      color: #7f7f7f;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      cursor: pointer;
    }
  }

  .tile-group-bottom-bar {
    width: 100%;
  }
</style>

<div class="tile-container">
  <div class="main-content">
    <PinnedListCarousel group={group} mobile={mobile} user={user} />
    <div>
      <a
        href={group.url}
        class="group-name-container"
        on:click|preventDefault|stopPropagation={(e) => {
          tileClicked(e);
        }}>
        {group.name}
      </a>
      <div class="group-metadata-container">
        {#if bookmarkId == null}
          <div class="authors">
            <ListAuthors
              nameMaxLinesShown={2}
              condensedView={true}
              group={group}
              showContributorModal={false}
              showContributorsTippyLabel={true}
              mobile={mobile}
              disableHyperlink={true}
              showNames={!mobile}
              contributorText={mobile ? '+[count]' : '+[remainingCount]'}
              authors={authors}
              skipBy={true} />
          </div>
        {/if}
      </div>
      {#if bookmarkId != null}
        <div class="groups-authors">
          <ListAuthors
            nameMaxLinesShown={1}
            group={group}
            showContributorModal={false}
            showContributorsTippyLabel={true}
            disableHyperlink={true}
            authors={authors}
            mobile={mobile}
            skipBy={true} />
        </div>
      {/if}

      {#if group.description && extractText(group.description) != ''}
        <a
          href={group.url}
          class="tile-group-description"
          on:click|preventDefault|stopPropagation={(e) => {
            tileClicked(e);
          }}>
          {extractText(group.description)}
        </a>
      {/if}
    </div>
  </div>
  <div class="tile-group-bottom-bar">
    <PinnedListActionsBar groupStore={group} group={group} displayStyle="tile" mobile={mobile} spotlightUser={user}/>
  </div>
</div>
